<template>
  <div class="c-ide-iframe">
    <iframe class="ide-iframe" frameborder="0" name="ideIframe" :src="frameUrl"></iframe>
  </div>
</template>

<script type="text/babel">
  import { mapGetters } from 'vuex';
  // import Env from '../../scripts/common/env'
  import aegis from '../../scripts/aegis'
  import Events from '../../scripts/events/index'
  import { emitEvent } from '../../utils/eventBus/vueEvent'
  import consoleStyle from '../../components/ide/consoleStyle'

  export default {
    name: 'c-ide-iframe',
    data() {
      return {
      }
    },
    computed: {
      ...mapGetters(['ideCode', 'prevCode', 'ideReady', 'isEdit']),
      frameUrl() {
        const url = 'https://qceit-static-1258274959.cos.ap-guangzhou.myqcloud.com/editor/ace1-4-12/editor/index210312.html';
        // const url = 'ttps://qceit-static-1258274959.cos.ap-guangzhou.myqcloud.com/editor/codemirror5-58-2/editor/index.html';
        let search = `origin=${encodeURIComponent(location.origin)}`
        // const ip = Env.signBit.getQueryIp(this.$route.query);
        // if (!(ip & Env.signBit.save || ip & Env.signBit.commit)) {
        if (!this.isEdit) {
          // ro -- readOnly， 1 | true
          search = `${search}&ro=1`
        }
        if (location.search) {
          return `${url}${location.search}&${search}`;
        }
        return `${url}?${search}`;
      },
    },
    mounted() {
      setTimeout(this.checkLoaded, 20000)
    },
    methods: {
      checkLoaded() {
        if (!this.ideReady) {
          aegis.report('iframe ide load error');
          // emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getErr('编辑区初始化超时，切换编辑...') })
          // this.$store.dispatch('setIsLocalIde', true)
          // this.$store.dispatch('setIsPyRuntimeCom', true)
          emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getErr('编辑器初始化异常，请尝试其他网络连接方式') })
          console.error('编辑器初始化异常，请尝试其他网络连接方式:例如4G热点')
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import "../../assets/scss/base/variables.scss";

  .c-ide-iframe {
    flex-grow: 1;
    display: flex;
  }

  .ide-iframe {
    flex-grow: 1;
  }
</style>
